/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/jsx-no-duplicate-props */
import React from 'react';
import { useState } from 'react';
import { client, urlFor } from '../client';
import {Link,useNavigate} from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';
import { MdDownloadForOffline } from 'react-icons/md';
import {AiTwotoneDelete,AiOutlineLike} from 'react-icons/ai'
import {BsFillArrowUpRightCircleFill} from 'react-icons/bs'
import { fetchUser } from '../utils/fetchUser';

const Pin = ({pin:{postedBy,image, _id, destination,save}}) => {

    const [postHovered, setPostHovered] = useState(false);
    const [savingPost, setSavingPost] = useState(false);
    const navigate = useNavigate()
    const user = localStorage.getItem('user') !=='undefined' ? JSON.parse(localStorage.getItem('user')) :localStorage.clear()
    let alreadySaved =save?.filter((item) => item?.postedBy?._id === user?.googleId);
    alreadySaved = alreadySaved?.length > 0 ? alreadySaved:[]
    ///
    const savePin =(id)=>{
        if(alreadySaved?.length === 0){
            setSavingPost(true)
            client
            .patch(id)
            .setIfMissing({save:[]})
            .insert('after','save[-1]',[{
                _key:uuidv4(),
                userId:user?.googleId,
                postedBy:{
                    _type:'postedBy',
                    _ref:user?.googleId
                }
            }])
            .commit()
            .then(()=>{
                window.location.reload()
                setSavingPost(false)
            })
        }
    }

    const deletePin =(id)=>{
        client.delete(id)
        .then(()=>{
            window.location.reload()
        })
    }

    // console.log(savePin());
    return (
    <div div className="m-2">
    <div 
        onMouseEnter={() => setPostHovered(true)}
        onMouseLeave={() => setPostHovered(false)}
        onClick={() => navigate(`/pin-detail/${_id}`)}
        className=" relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out"
        >
        
           <img src={urlFor(image).width(250).url()} alt="user-img" className='rounded-lg w-full' />
           
           {
               postHovered && 
                   <div  className="absolute top-0 w-full h-full flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-50"
                   style={{ height: '100%' }}
                   >

                   <div className='flex items-center justify-between '>
                    <div className='flex gap-2'>
                    <a 
                  href={`${image?.asset?.url}?dl=`}
                  download
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="bg-white w-9 h-9 p-2 rounded-full flex items-center justify-center text-dark text-xl opacity-75 hover:opacity-100 hover:shadow-md outline-none hover-item"
                    >
                        <MdDownloadForOffline />
                    </a>
                   </div>

                   {
                       alreadySaved?.length !== 0 ?
                          ( <button className='saved-btn' type='button'  
                            > <i class="fas fa-heart"></i> <span className='font-size-must-be-little-size'>{save?.length}</span></button>)
                       :(
                           <button 
                           onClick={(e)=>{e.stopPropagation()
                            savePin(_id)}                           
                          }
                          type='button'
                          className='saved-btn'
                          ><i class="fas fa-heart"></i><span className='font-size-must-be-little-size'>{save?.length}</span></button>)
                   }
                   </div>
                   <div className="flex justify-between items-center gap-2 w-full">
                       {
                           destination && (
                               <a 
                               href={destination}
                               target="_blank"
                               className="bg-white flex items-center gap-2 text-black font-bold p-2 pl-4 pr-4 rounded-full opacity-70 hover:opacity-100 hover:shadow-md"
                               rel="noreferrer"
                               >
                                <BsFillArrowUpRightCircleFill/>
                                { 
                                destination.length > 20 ? destination.slice(8,20) : destination.slice(8)
                                }
                               </a>
                           )
                       }
                       {
                           postedBy?._id === user?.googleId && (
                               <button 
                               type='button'
                               onClick={(e)=>{e.stopPropagation(); deletePin(_id)}}
                               className="bg-white p-2 rounded-full w-8 h-8 flex items-center justify-center text-dark opacity-75 hover:opacity-100 outline-none"
                               >
                             <AiTwotoneDelete/>
                               </button>
                           )
                       }
                   </div>
                  
                   </div>
                    }
        
        </div>
                   <Link to={`/user-profile/${postedBy?._id}`} className="flex gap-2 mt-2 items-center">
                     <img src={postedBy?.image} className='w-8 h-8 rounded-full object-cover' alt="" />
                     <p className="font-semibold capitalize">{postedBy?.userName}</p>
                    </Link>
        </div>
    );
};

export default Pin;